import React from 'react';
import { Svg } from '@hmhco/svg';
import { PLATFORMS, usePlatform } from '@hmhco/platform-helper';
import HmhGraphics from '@ed/baseline/VAL/hmh/hmh-ed-login-2025.svg';
import NweaGraphics from '@ed/baseline/images/login-illustrations/nwea-login-illustration.svg';
import HeinemannImage from '@ed/baseline/images/login-illustrations/hnm-background.png';
import AIToolsGraphics from './AI Tools_Login_Illustration.svg';
import WritableGraphics from './Ed_Writable_Login_Illustration.svg';
import useStyles from './Marketing.styles';

const Marketing = () => {
  const platform = usePlatform();
  const { cx, classes } = useStyles();

  switch (platform) {
    case PLATFORMS.WRITABLE: {
      return (
        <div className={cx(classes.root, classes.hmhAiTools)}>
          <div
            data-testid="marketing-image"
            role="presentation"
            className={cx(classes.image, classes.hmhImage)}
          >
            <Svg svg={WritableGraphics} />
          </div>
        </div>
      );
    }
    case PLATFORMS.AI_TOOLS: {
      return (
        <div className={cx(classes.root, classes.hmhAiTools)}>
          <div
            data-testid="marketing-image"
            role="presentation"
            className={cx(classes.image, classes.hmhImage)}
          >
            <Svg svg={AIToolsGraphics} />
          </div>
        </div>
      );
    }
    case PLATFORMS.NWEA: {
      return (
        <div className={cx(classes.root, classes.nwea)}>
          <div
            data-testid="marketing-image"
            role="presentation"
            className={cx(classes.image, classes.nweaImage)}
          >
            <Svg svg={NweaGraphics} />
          </div>
        </div>
      );
    }
    case PLATFORMS.FLIGHT: {
      return (
        <div className={cx(classes.root, classes.heinemann)}>
          <div
            data-testid="marketing-image"
            role="presentation"
            className={cx(classes.image, classes.heinemannImage)}
            style={{
              backgroundImage: `url(${HeinemannImage})`,
            }}
          />
        </div>
      );
    }
    case PLATFORMS.ED:
    default: {
      return (
        <div className={cx(classes.root, classes.hmh)}>
          <div
            data-testid="marketing-image"
            role="presentation"
            className={cx(classes.image, classes.hmhImage)}
          >
            <Svg svg={HmhGraphics} />
          </div>
        </div>
      );
    }
  }
};

export default Marketing;
